import BaseComponent from "../components/BaseComponent";
import {Div, Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import MainMenu from "../components/MainMenu";
import SalePointMonitoringDocs from "../salePointsMonitoring/Docs";
import SalePointMonitoringStep1 from "../salePointsMonitoring/Step1";
import TakeAPhoto from "../components/TakeAPhoto";
import SalePointMonitoringStep2 from "../salePointsMonitoring/Step2";
import SalePointMonitoringStepVideo from "../salePointsMonitoring/StepVideo";
import SalePointMonitoringStep3 from "../salePointsMonitoring/Step3";
import SalePointMonitoringStep4Questionnaire from "../salePointsMonitoring/Step4Questionnaire";
import SalePointMonitoringStep5 from "../salePointsMonitoring/Step5";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import * as constants from "../assets/constants";
import KlientsApi from "../api/references/klients";
import StandsApi from "../api/references/stands";
import SalePointMonitoringStep1Old from "../salePointsMonitoring/Step1Old";
import TakeAPhotoToQueue from "../components/TakeAPhotoToQueue";
import { OfflineProvider } from "../contexts/OfflineContext";
import SalePointMonitoringDocsApi from "../api/SalePointMonitoringDocs";
import {ACCESS_DENIED_MESSAGE, isTradeDesigner} from "../assets/constants";

class FragmentSalePointMonitoring extends BaseComponent {
    constructor(props) {
        super(props)
        const state = {
            activePanelSalePointMonitoring: "sale_point_monitoringdocs_panel",
            current_klient: null,
            current_sale_point: null,
            current_sale_mall: null,
            current_brand: null,
            current_brandcollection: null,
            current_equipment: null,
            current_sale_point_monitoring: null,
            getImageEventName: "setImage",

        }

        this.state = {
            ...this.state,
            ...state
        }
    }


    render() {
        if (isTradeDesigner(this.props.current_user)) {
            return <OfflineProvider>
                <View activePanel="sale_point_monitoringdocs_panel"
                         id="sale_point_monitoring_story">
                    <Panel id="sale_point_monitoringdocs_panel">
                        <SplitLayout>
                            {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                            <SplitCol>
                                <Div style={{marginTop: 16}}>
                                    <h3>{ACCESS_DENIED_MESSAGE}</h3>
                                    <p>Мониторинг торговых точек недоступен для роли Дизайнер.</p>
                                </Div>
                            </SplitCol>
                        </SplitLayout>
                    </Panel>
                </View>
            </OfflineProvider>
        }
        return <OfflineProvider>
            <View activePanel={this.state.activePanelSalePointMonitoring}
                     id="sale_point_monitoring_story">
            <Panel id="sale_point_monitoringdocs_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SalePointMonitoringDocs
                            base_url={this.props.base_url}
                            date_range
                            current_user={this.props.current_user}
                            title="Мониторинг торговых точек"
                        />
                    </SplitCol>
                    {AdaptivityContext.w > 1600 && <SplitCol>

                    </SplitCol>}
                </SplitLayout>
            </Panel>

            <Panel id="salepointmonitoring_step1_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                            <SalePointMonitoringStep1
                                item={this.state.current_sale_point_monitoring}
                                current_user={this.props.current_user}
                                base_url={this.props.base_url}
                            />
                    </SplitCol>
                    {AdaptivityContext.w > 1600 && <SplitCol>

                    </SplitCol>}

                </SplitLayout>

            </Panel>

            <Panel id="salepointmonitoring_step2_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                    <SplitCol>
                        <SalePointMonitoringStep2
                            father={this}
                            current_document={this.state.current_sale_point_monitoring}
                            current_user={this.props.current_user}
                            base_url={this.props.base_url}
                        />
                    </SplitCol>
                    {false && !AdaptivityContext.isMobile && <SplitCol>

                    </SplitCol>}

                </SplitLayout>
            </Panel>
            <Panel id="salepointmonitoring_step3_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SalePointMonitoringStepVideo
                            current_document={this.state.current_sale_point_monitoring}
                            current_user={this.props.current_user}
                            base_url={this.props.base_url}
                        />
                    </SplitCol>
                    {AdaptivityContext.w > 1600 && <SplitCol>

                    </SplitCol>}

                </SplitLayout>
            </Panel>

            <Panel id="salepointmonitoring_step4_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol>
                        <SalePointMonitoringStep3
                            current_document={this.state.current_sale_point_monitoring}
                            current_user={this.props.current_user}
                            base_url={this.props.base_url}
                        />
                    </SplitCol>
                    {AdaptivityContext.w > 1600 && <SplitCol>

                    </SplitCol>}

                </SplitLayout>
            </Panel>

            <Panel id="salepointmonitoring_step5_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' :this.MainMenu()}
                    <SplitCol>
                        <SalePointMonitoringStep4Questionnaire
                            current_document={this.state.current_sale_point_monitoring}
                            current_user={this.props.current_user}
                            base_url={this.props.base_url}
                        />
                    </SplitCol>
                    {!AdaptivityContext.isMobile && <SplitCol>

                    </SplitCol>}

                </SplitLayout>
            </Panel>

            <Panel id="salepointmonitoring_step6_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' :this.MainMenu()}
                    <SplitCol>
                        <SalePointMonitoringStep5
                            item={this.state.current_sale_point_monitoring}
                            current_user={this.props.current_user}
                            base_url={this.props.base_url}
                        />
                    </SplitCol>
                    {!AdaptivityContext.isMobile && <SplitCol>

                    </SplitCol>}

                </SplitLayout>
            </Panel>

        </View>
        </OfflineProvider>
    }

    componentDidMount() {
        super.componentDidMount()
        if (isTradeDesigner(this.props.current_user)) {
            return
        }
        this.parseUrlAndLoadDocument()
    }

    parseUrlAndLoadDocument = () => {
        const url = window.location.href
        const baseUrl = this.state.url + (url.includes('/react/') ? '/react' : '')
        const urlPart = url.split(baseUrl)[1] || ''
        const urlParts = urlPart.split('/').filter(p => p && !p.includes('?'))

        if (urlParts.length >= 2 && urlParts[0] === 'sale_point_monitoring') {
            const docIdOrDraft = urlParts[1]
            const stepNumber = parseInt(urlParts[2]) || 1

            if (docIdOrDraft === 'draft') {
                // Восстанавливаем состояние из localStorage для оффлайн документа
                this.restoreFromLocalStorage(stepNumber)
            } else {
                const docId = parseInt(docIdOrDraft)
                if (docId && docId > 0 && !isNaN(docId)) {
                    // Загружаем документ по ID с сервера
                    SalePointMonitoringDocsApi.getOne(docId).then(response => {
                        const {data} = response
                        if (data.doc_data && data.doc_data.id) {
                            const newState = {
                                current_sale_point_monitoring: data
                            }
                            // Определяем панель на основе номера шага
                            if (stepNumber >= 1 && stepNumber <= 6) {
                                newState.activePanelSalePointMonitoring = `salepointmonitoring_step${stepNumber}_panel`
                            } else {
                                newState.activePanelSalePointMonitoring = 'salepointmonitoring_step1_panel'
                            }
                            this.setState(newState)
                        }
                    }).catch(error => {
                        console.error('Error loading document:', error)
                        // При ошибке пробуем восстановить из localStorage
                        this.restoreFromLocalStorage(stepNumber)
                    })
                }
            }
        } else {
            // Нет параметров в URL, проверяем localStorage только если там есть данные
            const savedDoc = localStorage.getItem(constants.values_sale_point_monitoring_key)
            if (savedDoc && savedDoc !== '') {
                this.restoreFromLocalStorage(1)
            }
        }
    }

    restoreFromLocalStorage = (defaultStep = 1) => {
        try {
            const savedDoc = localStorage.getItem(constants.values_sale_point_monitoring_key)
            const savedStep = localStorage.getItem(constants.current_sale_point_monitoring_step_key)

            if (savedDoc && savedDoc !== '') {
                const doc = JSON.parse(savedDoc)
                const stepNumber = savedStep ? parseInt(savedStep) : defaultStep

                const newState = {
                    current_sale_point_monitoring: doc
                }

                if (stepNumber >= 1 && stepNumber <= 6) {
                    newState.activePanelSalePointMonitoring = `salepointmonitoring_step${stepNumber}_panel`
                } else {
                    newState.activePanelSalePointMonitoring = 'salepointmonitoring_step1_panel'
                }

                this.setState(newState)

                // Обновляем URL для восстановленного документа
                if (doc && doc.doc_data && doc.doc_data.id > 0) {
                    this.updateUrl(doc.doc_data.id, stepNumber)
                } else {
                    // Это оффлайн документ (черновик)
                    this.updateUrl('draft', stepNumber)
                }
            }
        } catch (error) {
            console.error('Error restoring from localStorage:', error)
        }
    }

    saveToLocalStorage = (document, stepNumber) => {
        try {
            if (document) {
                localStorage.setItem(constants.values_sale_point_monitoring_key, JSON.stringify(document))
            }
            if (stepNumber) {
                localStorage.setItem(constants.current_sale_point_monitoring_step_key, stepNumber.toString())
            }
        } catch (error) {
            console.error('Error saving to localStorage:', error)
        }
    }

    clearLocalStorage = () => {
        try {
            localStorage.setItem(constants.values_sale_point_monitoring_key, '')
            localStorage.setItem(constants.current_sale_point_monitoring_step_key, '')
        } catch (error) {
            console.error('Error clearing localStorage:', error)
        }
    }

    updateUrl = (docId, stepNumber) => {
        try {
            if (docId && stepNumber) {
                // docId может быть числом (для сохраненных документов) или 'draft' (для оффлайн)
                const newUrl = `${this.state.url}/sale_point_monitoring/${docId}/${stepNumber}`
                window.history.pushState(null, null, newUrl)
            } else {
                // Если документ не открыт, возвращаемся к базовому URL
                const newUrl = `${this.state.url}/sale_point_monitoring`
                window.history.pushState(null, null, newUrl)
            }
        } catch (e) {
            console.error('Error updating URL:', e)
        }
    }

    getStepNumberFromPanel = (panelName) => {
        // Извлекаем номер шага из названия панели
        const match = panelName.match(/step(\d+)_panel/)
        return match ? parseInt(match[1]) : 1
    }

    componentWillUnmount() {
        super.componentWillUnmount()
    }

    receiveMessage = (event) => {
        if (isTradeDesigner(this.props.current_user)) {
            return
        }

        if (event.data.type !== undefined && event.data.type === 'setStep') {

            let newData = {}

            const lowerName = event.data.objectName.toLowerCase()
            const panelName = `${event.data.objectName.toLowerCase()}_step${event.data.numStep}_panel`
            newData[`activePanel${event.data.objectName}`] = panelName

            // Обновляем URL и сохраняем в localStorage если открыт документ
            if (event.data.objectName === 'SalePointMonitoring' && this.state.current_sale_point_monitoring) {
                const stepNumber = event.data.numStep
                const doc = this.state.current_sale_point_monitoring
                
                // Сохраняем в localStorage
                this.saveToLocalStorage(doc, stepNumber)

                // Обновляем URL
                if (doc.doc_data && doc.doc_data.id > 0) {
                    this.updateUrl(doc.doc_data.id, stepNumber)
                } else {
                    // Оффлайн документ или новый документ
                    this.updateUrl('draft', stepNumber)
                }
            }

            this.setState(newData)
            return
        }
        if (event.data.type !== undefined && event.data.type === 'setCurrentKlient') {

            console.log(event)

            const old = this.state.current_sale_point_monitoring
            const old_sp = this.state.current_sale_point

            if (true || event.data.value === null || (event.data.value && event.data.value.id && event.data.value.id > 0)) {
                if (old && old.doc_data) {
                    old.doc_data.klient = event.data.value
                }
                if (old_sp) {
                    old_sp.klient = event.data.value
                    old_sp.klient_id = event.data.value.id ?? event.value.uid
                }

                // Сохраняем обновленное состояние в localStorage
                if (old) {
                    const currentStep = this.getStepNumberFromPanel(this.state.activePanelSalePointMonitoring)
                    this.saveToLocalStorage(old, currentStep)
                }

                this.setState({
                    current_sale_point_monitoring: old,
                    current_sale_point: old_sp,
                    current_klient: event.data.value,

                })
            } else {
                this.setState({
                    current_klient: event.data.value,


                })
            }

            return
        }
        if (event.data.type !== undefined && event.data.type === 'reloadCurrentKlient' && this.state.current_klient.id > 0) {
            KlientsApi.getOne(this.state.current_klient.id).then(response => {
                const {data} = response

                if (data.id) {
                    this.setState({
                        current_klient: data,
                        activePanelSalePointMonitoring: 'salepointmonitoring_add_klient_panel'
                    })

                }
            })

            return
        }

        if (event.data.type !== undefined && event.data.type === 'setCurrentBrand') {
            console.log(event)
            if (event.data.fromSalePointMonitoring) {
                this.setState({
                    current_brand: event.data.value,
                    activePanelSalePointMonitoring: 'salepointmonitoring_add_brand_panel'
                })

            }
            return
        }
        if (event.data.type !== undefined && event.data.type === 'reloadCurrentBrand' && this.state.current_brand.id > 0) {
            StandsApi.getOne(this.state.current_brand.id).then(response => {
                const {data} = response

                if (data.id) {
                    this.setState({current_brand: data, activePanelBrands: 'panel_brands_item'})
                }
            })

            return
        }

        if (event.data.type !== undefined && event.data.type === 'setCurrentSalePoint') {

            const old = this.state.current_sale_point_monitoring

            if (true || event.data.value === null || event.data.value && event.data.value.id && event.data.value.id > 0) {
                console.log(event.data.value)

                old.doc_data.sale_point = event.data.value
                old.doc_data.sale_point.uid = event.data.value.id

                // Сохраняем обновленное состояние в localStorage
                const currentStep = this.getStepNumberFromPanel(this.state.activePanelSalePointMonitoring)
                this.saveToLocalStorage(old, currentStep)

                this.setState({
                    current_sale_point_monitoring: old,
                    current_sale_point: event.data.value,


                })
            } else {
                this.setState({
                    current_sale_point: event.data.value,
                })
            }

            return
        }

        if (event.data.type !== undefined && event.data.type === 'setCurrentMall') {


            const old = this.state.current_sale_point_monitoring

            if (true || event.data.value === null || event.data.value && event.data.value.id && event.data.value.id > 0) {


                old.doc_data.mall = event.data.value
                old.doc_data.mall.uid = event.data.value.id

                // Сохраняем обновленное состояние в localStorage
                const currentStep = this.getStepNumberFromPanel(this.state.activePanelSalePointMonitoring)
                this.saveToLocalStorage(old, currentStep)

                this.setState({
                    current_sale_point_monitoring: old,
                    current_mall: event.data.value,
                    // activePanelSalePointMonitoring: 'salepointmonitoring_step1_panel'

                })
            } else {
                this.setState({
                    current_mall: event.data.value,
                    // activePanelSalePointMonitoring: 'salepointmonitoring_add_sale_point_panel'

                })
            }

            return
        }

        if (event.data.type !== undefined && event.data.type === 'setCurrentSalePointMonitoring') {

            const current_sale_point_monitoring = event.data.value

            const newState = {
                current_sale_point_monitoring: current_sale_point_monitoring
            }

            if (event.data.goToStep1) {
                newState.activePanelSalePointMonitoring = 'salepointmonitoring_step1_panel'
            }

            const stepNumber = event.data.goToStep1 ? 1 : this.getStepNumberFromPanel(newState.activePanelSalePointMonitoring || this.state.activePanelSalePointMonitoring)

            // Сохраняем в localStorage
            this.saveToLocalStorage(current_sale_point_monitoring, stepNumber)

            // Обновляем URL при открытии документа
            if (current_sale_point_monitoring && current_sale_point_monitoring.doc_data && current_sale_point_monitoring.doc_data.id > 0) {
                const docId = current_sale_point_monitoring.doc_data.id
                this.updateUrl(docId, stepNumber)
            } else {
                // Новый документ (id = -1) или оффлайн документ
                this.updateUrl('draft', stepNumber)
            }

            this.setState(newState)

            return
        }

        if (event.data.type !== undefined && event.data.type === 'endSalePointMonitoring') {
            this.setState({activePanelSalePointMonitoring: 'sale_point_monitoringdocs_panel',})
            this.updateUrl(null, null) // Сбрасываем URL при завершении
            this.clearLocalStorage() // Очищаем localStorage

            this.openLoadingNoty("Документ успешно сохранен", 2000, true)
            setTimeout(() => this.clearSalePointMonitoringData(constants.CODE_FACING_MONITORING_STATUS_IN_PROCESS), 1000)
        }
        if (event.data.type !== undefined && event.data.type === 'goToSalePointMonitoringDocs') {

            if (this.state.current_sale_point_monitoring) {
                this.clearSalePointMonitoringData()
            }

            this.setState({
                activePanelSalePointMonitoring: 'sale_point_monitoringdocs_panel'
            })
            this.updateUrl(null, null) // Сбрасываем URL при возврате к списку
            this.clearLocalStorage() // Очищаем localStorage
            return
        }


        if (event.data.type !== undefined && event.data.type === 'last_monitoring_product_name' && event.data.productName) {
            this.setState({last_monitoring_product_name: event.data.productName})
            return
        }
    }

    clearSalePointMonitoringData = (status = constants.CODE_SALE_POINT_MONITORING_STATUS_NEW) => {
        this.clearLocalStorage()
        this.setState({current_sale_point_monitoring: null})
    }
}

export default FragmentSalePointMonitoring